import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelCommand, se_DescribeChannelCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannel", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelCommand")
    .f(void 0, DescribeChannelResponseFilterSensitiveLog)
    .ser(se_DescribeChannelCommand)
    .de(de_DescribeChannelCommand)
    .build() {
}
